import { logger } from "@scott/logger";
export type PlpViewMode = "list" | "grid";

const PLP_VIEW_MODE_STORAGE_KEY = "plpViewMode";

const listeners = new Set<() => void>();

export function normalizePlpViewMode(
  value?: string | null
): PlpViewMode | null {
  return value === "list" || value === "grid" ? value : null;
}

export function readStoredPlpViewMode(): PlpViewMode | null {
  try {
    return normalizePlpViewMode(
      window.sessionStorage.getItem(PLP_VIEW_MODE_STORAGE_KEY)
    );
  } catch (_e) {
    // Storage unavailable (e.g. blocked by the browser) - fall back to default
    return null;
  }
}

export function storePlpViewMode(viewMode: PlpViewMode): void {
  try {
    window.sessionStorage.setItem(PLP_VIEW_MODE_STORAGE_KEY, viewMode);
  } catch (_e) {
    logger.log("Failed to persist PLP view mode in session storage", {
      error: _e,
    });
  }
  for (const listener of listeners) {
    listener();
  }
}

/** Remove the persisted PLP view mode (e.g. on logout) and notify subscribers. */
export function clearStoredPlpViewMode(): void {
  try {
    window.sessionStorage.removeItem(PLP_VIEW_MODE_STORAGE_KEY);
  } catch (_e) {
    logger.log("Failed to clear PLP view mode from session storage", {
      error: _e,
    });
  }
  for (const listener of listeners) {
    listener();
  }
}

/** Subscribe for `useSyncExternalStore`; fires on every `storePlpViewMode`. */
export function subscribePlpViewMode(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

/** Server snapshot: there is no storage during SSR, so use the default. */
export function getServerPlpViewMode(): PlpViewMode | null {
  return null;
}
